<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
    <div fxFlex="50">
        <app-order-email-templates></app-order-email-templates>
    </div>
    <div fxFlex="50">
        <app-invoice-email-templates></app-invoice-email-templates>
    </div>
    <div fxFlex="50">
      <app-push-notification-templates></app-push-notification-templates>
      <app-invoice-pdf-templates></app-invoice-pdf-templates>
        <app-total-card-email-templates></app-total-card-email-templates>
        <app-order-sms-templates></app-order-sms-templates>
      <app-user-email-templates></app-user-email-templates>
      <app-other-templates></app-other-templates>
    </div>
    <div fxFlex="50">
        <app-customer-email-templates></app-customer-email-templates>

    </div>
</div>
